/**
 * Library version.
 * @type {string}
 */
export const version = '__OTPAUTH_VERSION__';
